import Vue from 'vue'

// для тестирования кнопок типа btn-icon-tip необходимо указывать атрибут KEY (смотри ProductQualities.vue)
const bind = (el, binding) => {
  // console.log('test directive')
  // console.log(process.env.NODE_ENV)
  // console.log({ ...process.env })
  if (process.env.VUE_APP_TEST && binding.value) {
    Object.keys(binding.value).forEach(value => {
      el.setAttribute(`data-test-${value}`, binding.value[value])
    })
  }
}
const inserted = (el, binding, vnode) => {
  if (process.env.VUE_APP_TEST && binding.value) {
    Object.keys(binding.value).forEach(value => {
      el.setAttribute(`data-test-${value}`, binding.value[value])
    })
  }
}

Vue.directive('test', {
  bind,
  inserted
})
